// extracted by css-extract-rspack-plugin
export default {"TabsListSidebar":"FilterTabList-module__TabsListSidebar___G28Lr"};